import { useCallback, useEffect, useMemo, useState } from 'react';
import { DEFAULT_STATUS_MAPPINGS } from './aws-cloud-details.constants';
import { EnvironmentStatusOptions, AWSCloudDetailsStatusMapping } from './aws-cloud-details.types';
export const useEnvironmentStatus = (environmentStatus: EnvironmentStatusOptions) => {
  const statusMappings: Record<string, AWSCloudDetailsStatusMapping> = useMemo(() => ({
    [EnvironmentStatusOptions.STARTING]: {
      tagType: 'error',
      circleIconColor: 'error',
      iconTagText: 'Not Ready',
      panelText: 'You do not have access to any environment',
      showRoomList: false,
      showClose: true,
      showGenerateEnvironment: false,
      showResetEnvironment: false
    },
    [EnvironmentStatusOptions.ACTIVE_BUT_EMPTY]: {
      tagType: 'success',
      circleIconColor: 'success',
      iconTagText: 'Active',
      panelText: 'You do not have access to any other environments',
      showRoomList: false,
      showClose: false,
      showGenerateEnvironment: true,
      showResetEnvironment: true
    },
    [EnvironmentStatusOptions.GENERATING_FIRST_ENVIRONMENT]: {
      tagType: 'warning',
      circleIconColor: 'warning',
      iconTagText: 'Generating',
      panelText: 'You do not have access to any other environments',
      showRoomList: false,
      showClose: true,
      showGenerateEnvironment: false,
      showResetEnvironment: false
    },
    [EnvironmentStatusOptions.ACTIVE]: {
      tagType: 'success',
      circleIconColor: 'success',
      iconTagText: 'Active',
      showRoomList: true,
      showClose: true,
      showGenerateEnvironment: false,
      showResetEnvironment: true
    },
    [EnvironmentStatusOptions.ANOTHER_ENVIRONMENT_ACTIVE]: {
      tagType: 'success',
      circleIconColor: 'success',
      iconTagText: 'Active',
      panelText: 'Please note that generating an environment for this room will destroy the environment used in previous rooms',
      showRoomList: true,
      showClose: false,
      showGenerateEnvironment: true,
      showResetEnvironment: true
    },
    [EnvironmentStatusOptions.GENERATING]: {
      tagType: 'warning',
      circleIconColor: 'warning',
      iconTagText: 'Generating',
      showRoomList: true,
      showClose: true,
      showGenerateEnvironment: false,
      showResetEnvironment: false
    },
    [EnvironmentStatusOptions.NEW_ENVIRONMENT]: {
      tagType: 'success',
      circleIconColor: 'success',
      iconTagText: 'Active',
      showRoomList: true,
      showClose: true,
      showGenerateEnvironment: false,
      showResetEnvironment: false
    },
    [EnvironmentStatusOptions.RESETTING]: {
      tagType: 'info',
      circleIconColor: 'info',
      iconTagText: 'Resetting',
      showRoomList: true,
      showClose: true,
      showGenerateEnvironment: false,
      showResetEnvironment: false
    }
  }), []);
  const getStatusMapping = useCallback((envStatus: EnvironmentStatusOptions) => statusMappings[envStatus] || DEFAULT_STATUS_MAPPINGS, [statusMappings]);
  const [statusMapping, setStatusMapping] = useState(getStatusMapping(environmentStatus));
  useEffect(() => {
    setStatusMapping(getStatusMapping(environmentStatus));
  }, [environmentStatus, getStatusMapping]);
  return {
    tagType: statusMapping.tagType,
    circleIconColor: statusMapping.circleIconColor,
    iconTagText: statusMapping.iconTagText,
    panelText: statusMapping.panelText,
    showRoomList: statusMapping.showRoomList,
    showClose: statusMapping.showClose,
    showGenerateEnvironment: statusMapping.showGenerateEnvironment,
    showResetEnvironment: statusMapping.showResetEnvironment
  };
};